// Central i18n configuration for FileNesto multilingual SEO architecture.
// LEVEL 1: indexable: true  → routes created + sitemap + hreflang (content fully translated)
// LEVEL 2: indexable: false → config prepared, routes NOT created, no sitemap entry

export const SUPPORTED_LANGUAGES = [
  { code: "en", prefix: "",    name: "English",    locale: "en_US", dir: "ltr", indexable: true,  flag: "🇬🇧" },
  { code: "fr", prefix: "/fr", name: "Français",   locale: "fr_FR", dir: "ltr", indexable: true,  flag: "🇫🇷" },
  { code: "es", prefix: "/es", name: "Español",    locale: "es_ES", dir: "ltr", indexable: true,  flag: "🇪🇸" },
  { code: "pt", prefix: "/pt", name: "Português",  locale: "pt_BR", dir: "ltr", indexable: true,  flag: "🇧🇷" },
  { code: "de", prefix: "/de", name: "Deutsch",    locale: "de_DE", dir: "ltr", indexable: true,  flag: "🇩🇪" },
  { code: "ar", prefix: "/ar", name: "العربية",    locale: "ar",    dir: "rtl", indexable: false, flag: "🇸🇦" },
  { code: "hi", prefix: "/hi", name: "हिंदी",      locale: "hi_IN", dir: "ltr", indexable: false, flag: "🇮🇳" },
  { code: "id", prefix: "/id", name: "Indonesia",  locale: "id_ID", dir: "ltr", indexable: false, flag: "🇮🇩" },
  { code: "tr", prefix: "/tr", name: "Türkçe",     locale: "tr_TR", dir: "ltr", indexable: false, flag: "🇹🇷" },
  { code: "it", prefix: "/it", name: "Italiano",   locale: "it_IT", dir: "ltr", indexable: false, flag: "🇮🇹" },
  { code: "ru", prefix: "/ru", name: "Русский",    locale: "ru_RU", dir: "ltr", indexable: false, flag: "🇷🇺" },
  { code: "vi", prefix: "/vi", name: "Tiếng Việt", locale: "vi_VN", dir: "ltr", indexable: false, flag: "🇻🇳" },
  { code: "ko", prefix: "/ko", name: "한국어",       locale: "ko_KR", dir: "ltr", indexable: false, flag: "🇰🇷" },
  { code: "pl", prefix: "/pl", name: "Polski",     locale: "pl_PL", dir: "ltr", indexable: false, flag: "🇵🇱" },
  { code: "nl", prefix: "/nl", name: "Nederlands", locale: "nl_NL", dir: "ltr", indexable: false, flag: "🇳🇱" },
];

// Codes of all known language prefixes (used for path detection)
export const LANG_CODES = SUPPORTED_LANGUAGES.filter((l) => l.code !== "en").map((l) => l.code);

// Languages with routes created and sitemap entries
export const INDEXABLE_LANGS = SUPPORTED_LANGUAGES.filter((l) => l.indexable);

// Languages shown in the Navbar switcher
export const SWITCHER_LANGS = SUPPORTED_LANGUAGES.filter((l) => l.indexable);

// Languages for which tool routes are generated
export const ACTIVE_ROUTE_LANGS = ["fr", "es", "pt", "de"];

// Detect language code from a pathname
export function getLangFromPath(pathname) {
  const match = pathname.match(new RegExp(`^\\/(${LANG_CODES.join("|")})(\\\/|$)`));
  return match ? match[1] : "en";
}

// Strip language prefix from a pathname → returns clean slug
export function getSlugFromPath(pathname) {
  const match = pathname.match(new RegExp(`^\\/(${LANG_CODES.join("|")})\\/?(.*)`));
  if (match) return match[2] || "";
  return pathname.replace(/^\//, "");
}

// Build a localized path from a base slug and a language code
export function buildLocalizedPath(slug, lang) {
  if (!slug) {
    return lang === "en" ? "/" : `/${lang}`;
  }
  return lang === "en" ? `/${slug}` : `/${lang}/${slug}`;
}

// Compute the target URL when the user switches language on a given pathname
export function switchLangPath(currentPathname, targetLang) {
  const slug = getSlugFromPath(currentPathname);
  return buildLocalizedPath(slug, targetLang);
}

// Return the hreflang attribute value for a language code
export function hreflangCode(langCode) {
  if (langCode === "pt") return "pt-BR";
  return langCode;
}
